module.exports = __webpack_public_path__ + "img/type_moving-floor_opening-side.d3c1c46b.jpg";